// src/app/reducers/customer.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  projectIsCreatedAction,
  removeRecentProjectAction
} from 'src/app/actions/project';

export interface ProjectState {
  projects: any[];
  recentProject?: any;
}

export const initialState: ProjectState = {
  projects: [],
  recentProject: null
};

const _projectReducer = createReducer(
  initialState,
  on(projectIsCreatedAction, (state, { newProject }) => ({
    ...state,
    projects: [...state.projects, newProject],
    recentProject: newProject
  })),
  on(removeRecentProjectAction, state => ({
    ...state,
    recentProject: null
  }))
);

export function projectReducer(
  state: ProjectState | undefined,
  action: Action
) {
  return _projectReducer(state, action);
}
